import { Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CurrencyPipe, Location } from '@angular/common';
import { LinkService } from '../shared/services/link.service';
import { FormsModule, NonNullableFormBuilder } from '@angular/forms';
import { InputFieldComponent } from '../shared/components/input-field/input-field.component';
import { LinkInformation } from '../shared/interfaces/link-information';

@Component({
  selector: 'app-payment-form',
  standalone: true,
  imports: [CurrencyPipe, InputFieldComponent, FormsModule],
  templateUrl: './payment-form.component.html',
  styleUrl: './payment-form.component.css'
})
export class PaymentFormComponent implements OnInit {

  linkInfo: LinkInformation = {}
  
  paymentMethod: string = '';

  paymentNumber = signal('');

  submited = false;

  nb = inject(NonNullableFormBuilder);
  
  form = this.nb.group({
    paymentNr: this.nb.control(''),
  })
  
  constructor(private router:Router,private route:ActivatedRoute, private location: Location, private linkServ: LinkService){}
  
  ngOnInit(){

    this.linkInfo = this.linkServ.getLinkInformation()
    
    if(this.linkInfo.amount == undefined){
      this.goBack()
    }

    this.paymentMethod = this.route.snapshot.paramMap.get("method")!;

    this.paymentNumber.set(this.linkServ.getPaymentNumber());
  }

  goBack(): void{ 
    this.linkServ.setPaymentInput('','');
    this.location.back();
  }

  getPattern():string{
    switch(this.paymentMethod){
      case 'mKesh': return '^8(2|3)[0-9]{7}$'
      case 'MPesa': return '^8(4|5)[0-9]{7}$'
      case 'eMola': return '^8(6|7)[0-9]{7}$'
      default : return '^8[2-7][0-9]{7}|[2-9][0-9]{8}$'
    }
  }

  onSubmit(){
    
    if(RegExp(this.getPattern()).test(this.paymentNumber())){
      this.linkServ.setPaymentInput(this.paymentMethod, this.paymentNumber())
      this.router.navigate(['pay/confirmation']);
    } else{
      this.submited = true
    }

  }
}
